var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dev@b9d7c4328abd9bf1a1ca5d7fb4f65c32b9947d8e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["paradigm-web@paradigmco"]={id:"dev@b9d7c4328abd9bf1a1ca5d7fb4f65c32b9947d8e"};
      